"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketExchangeAllowedEnum = void 0;
var TicketExchangeAllowedEnum;
(function (TicketExchangeAllowedEnum) {
    TicketExchangeAllowedEnum["Always"] = "Always";
    TicketExchangeAllowedEnum["Never"] = "Never";
    TicketExchangeAllowedEnum["After"] = "After event is sold out";
    TicketExchangeAllowedEnum["Percent"] = "After a percent of tickets are sold";
})(TicketExchangeAllowedEnum = exports.TicketExchangeAllowedEnum || (exports.TicketExchangeAllowedEnum = {}));
//# sourceMappingURL=ITicketExchange.js.map